import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';

import { CaptionText, P2, P3 } from '../../../styles/FontStyles';
import { PaymentSuccess } from './PaymentSuccess';

import Spinner from '../Spinner';

import { VirtualOfficeSubscription } from './VirtualOfficeSubscription';
import { InputBackOffice } from '../InputBackoffice';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import euroVat from '../../../assets/icons/backOffice/euroVat.svg';
import { VirtualOfficePlan } from './VirtualOfficePlan';
import { USDT } from '../../../helpers/helperFunctions';
import PaymentPage from '../../../views/Marketplace/PurchasePackageAndCombo/PaymentPage';
import { Success } from '../../../views/Marketplace/PurchasePackageAndCombo/Success';
import { PurchaseSteps } from '../../../views/Marketplace/Maeketplace.types';
import { Failed } from '../../../views/Marketplace/PurchasePackageAndCombo/Failed';

interface SelectedPlanProps {
  selected: any;
  setSelected: any;
  step: number;
}

export const SelectedPlan = ({
  selected,
  setSelected,
  step
}: SelectedPlanProps) => {
  const { loading, loadingVerification } = useAppSelector(
    (state) => state.settings
  );
  const { addHubLoading, loading: creditCardLoading } = useAppSelector(
    (state) => state.marketplace
  );

  const showSteps = (step: number) => {
    switch (step) {
      case PurchaseSteps.PAYMENT_METHOD:
        return (
          <>
            {/* <P2>{`${PROJECT_NAME} Back-Office is your entry to limitless possibilities! Secure your plan and start earning!`}</P2> */}

            <P2 mb={'30'}>
              Travelution Back-Office is your entry to limitless possibilities!
              Secure your plan and start earning!
            </P2>
            <VirtualOfficePlan selected={selected} setSelected={setSelected} />
            <P2 mb={'30'} mt={'40'}>
              It is highly advised to select a multi-year access and{' '}
              <b>avoid the big risk</b> of losing the benefits in case you do
              not renew the Back-Office in time.
            </P2>
            <P3 bold mb='8'>
              Payment Amount
            </P3>

            <InputBackOffice
              disabled
              value={selected?.totalPrice}
              icon={euroVat}
            />
            <Flexed between>
              <div>
                <CaptionText color={lightTheme.colors.neutral500}>
                  VAT amount: {selected?.vatPrice} {USDT}
                </CaptionText>
                <CaptionText mb='20' color={lightTheme.colors.neutral500}>
                  Payment gateway processing fee: {selected?.feePrice} {USDT}
                </CaptionText>
              </div>
              <div>
                <CaptionText color={lightTheme.colors.neutral500}>
                  VAT percentage: {selected?.vatPercentage}%
                </CaptionText>
              </div>
            </Flexed>

            <VirtualOfficeSubscription selected={selected} />
          </>
        );

      case PurchaseSteps.PAYMENT_PAGE:
        return <PaymentPage selectedPackage={selected} />;

      case PurchaseSteps.SUCCESS:
        return <Success />;

      case PurchaseSteps.FAILED:
        return <Failed />;

      default:
        return null;
    }
  };
  return (
    <>
      {loading || addHubLoading || creditCardLoading || loadingVerification ? (
        <Spinner />
      ) : (
        <>{showSteps(step)}</>
      )}
    </>
  );
};
